<template>
  <div>
    <el-form :model="sheetForm" ref="sheetForm">
      <el-row style="margin-bottom: 10px;">
        <el-button type="primary" @click="onConfirmSheet" v-if="operationType!=='view'">{{ $t('common.confirm') }}</el-button>
        <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
      </el-row>
      <el-table :data="sheetForm.tableData" border row-key="id" ref="sortableTable" style="width: 100%;">
        <el-table-column prop="processCode" label="制成编码" min-width="120" align="center"></el-table-column>
        <el-table-column prop="processName" label="制成名称" min-width="180" align="center"></el-table-column>
        <el-table-column prop="factorCode" label="指标编码" min-width="120" align="center"></el-table-column>
        <el-table-column prop="factorName" label="指标名称" min-width="180" align="center"></el-table-column>
        <el-table-column prop="sheetName" label="Sheet Name" min-width="180" align="center">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableData.' + scope.$index + '.sheetName' ">
              <el-input v-model="scope.row.sheetName" :disabled="operationType=='view'"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="sheetIndex" label="Sheet Index" min-width="100" align="center">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableData.' + scope.$index + '.sheetIndex' ">
              <el-input v-model="scope.row.sheetIndex" :disabled="operationType=='view'"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    sheetData: {
      type: Array,
      default: () => [] // 默认值为空数组
    },
    operationType: {
      type: String,
    }
  },
  data() {
    return {
      sheetForm: {
        tableData: []
      },
      rules: {}
    }
  },
  watch: {
    sheetData: {
      handler(newVal) {
        console.log("🚀 ~ handler ~ newVal:", newVal)
        console.log("🚀 ~ handler ~ newVal:", JSON.stringify(newVal))
        this.sheetForm.tableData = [...newVal]
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onConfirmSheet() {
      this.$refs['sheetForm'].validate((valid) => {
        if (valid) {
          const result = this.validateSheetData(this.sheetForm.tableData);
          console.log("🚀 ~ onConfirmSheet ~ result:", result)
          if (result.valid) {
            this.$emit('setSheetSort', this.sheetForm.tableData)
          } else {
            this.$message.error(result.error)
          }
        }
      })
    },
    onCancel() {
      this.sheetForm.tableData = []
      this.$emit('cancelSheetSort')
    },
    // sheetNameRules(index, row) {
    //   return (this.rules["sheetName"] = [
    //     {
    //       validator: (rule, value, callback) => {
    //         if (!value) {
    //           return callback(new Error('请填写Sheet Name'));
    //         }
    //         callback();
    //       },
    //       trigger: "blur",
    //     },
    //   ]);
    // },
    // sheetIndexRules(index, row) {
    //   return (this.rules["sheetIndex"] = [
    //     {
    //       validator: (rule, value, callback) => {
    //         if (!value) {
    //           return callback(new Error('请填写Sheet Index'));
    //         }
    //         callback();
    //       },
    //       trigger: "blur",
    //     },
    //   ]);
    // },
    validateSheetData(data) {
      // 创建一个对象存储每个sheetName对应的sheetIndex
      const sheetMap = {};
      // 遍历数据进行检查
      for (const item of data) {
        const { sheetName, sheetIndex } = item;
        // 如果该sheetName已存在于映射中
        if (sheetMap.hasOwnProperty(sheetName)) {
          // 检查当前sheetIndex是否与已存储的一致

          if (sheetMap[sheetName] != sheetIndex) {
            return {
              valid: false,
              error: `sheetName为"${sheetName}"的记录存在不同的sheetIndex值: ${sheetMap[sheetName]}和${sheetIndex}`
            };
          }
        } else {
          // 首次遇到该sheetName，存储其sheetIndex
          sheetMap[sheetName] = sheetIndex;
        }
      }

      // 所有检查通过
      return { valid: true };
    },
  }
}
</script>